import React, { useEffect, useState } from 'react';
import { useLocation } from 'wouter';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';


interface ModalSessionExpiryProps {
  show: boolean;
  onExtendSession: () => void;
}
const ModalSessionExpiry = ({ show, onExtendSession }: ModalSessionExpiryProps) => {
  const [isVisible, setIsVisible] = useState(show);
  const [_, setLocation] = useLocation();

  useEffect(() => {
    setIsVisible(show);
  }, [show]);

  const onLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('originalPath');
    setIsVisible(false);
    setLocation('/login');
  };

  return (
    <Modal show={isVisible} onHide={onLogout}>
      <Modal.Header closeButton>
        <Modal.Title>Su sesión está a punto de caducar</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        ¿Quiere extender su sesión actual?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onLogout}>
          Cancelar
        </Button>
        <button className="primary-bg-btn p-2" onClick={onExtendSession}>
          Extender sesión
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalSessionExpiry;
